export default "__VITE_ASSET__CaPN5hAD__"